import type { UserDetail } from '@planuze/admin-contracts';
import { useUsersContent } from '../../../content/sections/users.js';
import { fmtDate } from '../../../lib/format.js';
import { DefinitionList, Field } from '../../detail-fields.js';

export function OverviewTab({ user }: { readonly user: UserDetail }) {
  const copy = useUsersContent();
  return (
    <DefinitionList>
      <Field label={copy.overviewTab.name} value={user.name} />
      <Field label={copy.overviewTab.username} value={`@${user.username}`} />
      <Field
        label={copy.overviewTab.emailVerifiedAt}
        value={
          user.emailVerifiedAt !== null
            ? fmtDate(user.emailVerifiedAt)
            : copy.overviewTab.emailUnverified
        }
      />
      <Field label={copy.overviewTab.createdAt} value={fmtDate(user.createdAt)} numeric />
      <Field label={copy.overviewTab.updatedAt} value={fmtDate(user.updatedAt)} numeric />
      <Field label={copy.overviewTab.orgsCount} value={user.orgs.length} numeric />
      <Field
        label={copy.overviewTab.activeLicensesCount}
        value={
          user.licensingAvailability.licenses === 'available'
            ? user.licenses.length
            : copy.detailHeader.unavailableMetric
        }
        numeric={user.licensingAvailability.licenses === 'available'}
      />
      <Field
        label={copy.overviewTab.idLabel}
        value={user.id}
        copyable
        copyLabel={copy.overviewTab.idLabel}
        full
      />
    </DefinitionList>
  );
}
